import React from 'react';
import { ChampionEmail } from '../components/email/ChampionEmail';
import { championEmail } from '../data/email';
export function EmailPreview() {
  return <main className="min-h-screen w-full bg-[#EEF0F4] px-4 py-10" data-id="element-278" data-mp="1jtdancsfd4np">
      <div className="mx-auto w-full max-w-[640px]" data-id="element-279" data-mp="1xpgy8n8smer7">
        <div className="rounded-t-xl border border-b-0 border-gray-200 bg-white px-5 py-4" data-id="element-280" data-mp="1sryqv1afc7lb">
          <h1 className="text-lg font-semibold text-[#14141F]" data-id="element-281" data-mp="1524gqrhhox4r">{championEmail.subject}</h1>
          <div className="mt-3 flex items-center gap-3" data-id="element-282" data-mp="1031jht7r3v7c">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy text-sm font-bold text-white" aria-hidden data-id="element-283" data-mp="104cplzoo5f1m">i9</span>
            <div className="min-w-0 text-sm" data-id="element-284" data-mp="1a1hbdyelr8hw">
              <p className="text-[#14141F]" data-id="element-285" data-mp="1a0fq713vh5mg">
                <span className="font-semibold" data-id="element-286" data-mp="mbmzbj23xnyp">{championEmail.fromName}</span>{' '}
                <span className="text-gray-500" data-id="element-287" data-mp="m9a8shiaa5a1">&lt;{championEmail.fromAddress}&gt;</span>
              </p>
              <p className="truncate text-gray-500" data-id="element-288" data-mp="hapfz35d2nvm">{championEmail.preheader}</p>
            </div>
          </div>
        </div>
        <ChampionEmail data-id="element-289" data-mp="13bak98m3mjoj" />
      </div>
    </main>;
}